import React from "react";
import { Button, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "@/axios/axiosInstance";
import "./BankCardConfirm.scss";

const BankCardConfirm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const bankInfo = location.state?.bankInfo;

  if (!bankInfo) {
    message.error("银行卡信息不完整，请重新填写");
    navigate("/personal/finance/bankcard");
    return null;
  }

  const handleConfirm = async () => {
    try {
      const response = await axiosInstance.post(
        "/finance/confirmBankCard",
        bankInfo
      );
      if (response.data.code === 10000) {
        message.success("银行卡绑定成功");
        navigate("/personal/finance/bankcard");
      } else {
        message.error(response.data.msg || "绑定失败");
      }
    } catch (error) {
      console.error("绑定银行卡失败:", error);
      message.error("绑定银行卡失败");
    }
  };

  const handleBack = () => {
    navigate("/personal/finance/bankcard");
  };

  return (
    <div className="bank-card-confirm-container">
      <div className="title">提现银行卡信息</div>

      <div className="info-section">
        <div className="info-item">
          <span className="label">持卡人信息：</span>
          <span className="value">{bankInfo.holderName}</span>
        </div>
        <div className="info-item">
          <span className="label">身份证号：</span>
          <span className="value">身份证号*****************7</span>
        </div>
      </div>

      <div className="bank-section">
        <div className="section-title">银行卡</div>
        <div className="bank-info">
          <div className="bank-item">
            <div className="bank-name">{bankInfo.bankName}</div>
            <div className="bank-detail">
              <div className="card-number">{bankInfo.cardNumber}</div>
              <div className="branch-name">{bankInfo.branchName}</div>
            </div>
            <div className="limit-info">限额12万元/天</div>
          </div>
        </div>
      </div>

      <div className="notice-section">
        <div className="notice-title">
          <span className="icon">🔔</span> 温馨提示：
        </div>
        <ol>
          <li>
            提现时请确保银行卡<span className="highlight">50元</span>
            以上方可提现
          </li>
          <li>提现时请确保银行卡处于正常状态，如遇到提现失败，请联系客服</li>
          <li>为确保资金安全，请务必填写本人银行卡，切勿填写他人银行卡</li>
          <li>如遇到问题，请联系客服处理</li>
          <li>
            一般情况下，请确保提现银行卡为储蓄卡，提现到信用卡可能导致提现失败
          </li>
        </ol>
      </div>

      <div className="action-section">
        <Button onClick={handleBack}>返回修改</Button>
        <Button type="primary" onClick={handleConfirm}>
          确认绑定
        </Button>
      </div>
    </div>
  );
};

export default BankCardConfirm;
